import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-banner-child',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="container banner grid grid-cols-2">
      <div class="content" style="width: 450px; color:white;">
        <strong style="font-size: 46px; font-family: Montserrat;">
          <span class="div-text">
            Dive
          </span>
          Into The Depths Of
          <span class="div-text">
            Virtual Reality
          </span>
        </strong>
        <p>
         Lets we create best something business with technology to help any people make easy only them hand can do everything
        </p>
        <div class="button grid grid-cols-2 mt-4">
          <button
            class="btn btn-outline-primary btn-build"
          >
            BUILD YOUR WORLD
          </button>

        </div>
      </div>
      <div class="box-image " style="margin-left: 20px;" >
        <div
          style="width: 524px; height: 455px; background: rgba(0, 0, 0, 0.13); border-radius: 100px 100px 100px 240px;"
        >
      <div class="dog">
        <img src="../../../../../assets/dark/dog.png" style="padding-top:120px;" alt="">
        <button class="btn btn-dog btn-outline-primary ">Take me out</button>
      </div>
      <div class="image-bg" style="position: absolute;">

      </div>
      </div>
      </div>
    </div>
  `,
  styleUrls: ['banner.component.scss'],
})
export class BannerChildComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
